import React from 'react'

import Tile from './tile'
import Figure from './figure'
import './tileMenu.css'

import {selectTile} from '../../actions/index'

const TileMenu = ({ tiles, selectedTile, selectedSample, onSelectTile }) => {
	const defaultColorScheme = 0;
	return (<div id="tile-menu">
		<div id="tile-container">
		{tiles.map((tile, tileIndex) => {
			return (
				<Tile 
					selected={ selectedTile === tileIndex}
					onSelectTile={() => onSelectTile(tileIndex, tile.colorScheme[0]) }>
					{tile.paths.map(( path, pathIndex ) => {
						return (
							<Figure 
								id={pathIndex} 
								key={pathIndex} 
								transform={path.transform} 
								d={path.d} 
								fill={tile.colorScheme[defaultColorScheme][pathIndex]}
							/>
						)
					})}
					
				</Tile>
			)
		})}
		</div>
		</div>)
}

export default TileMenu;


// WEBPACK FOOTER //
// ./src/components/mosaic/tileMenu.jsx